import clsx from "clsx";
import TwoSidebars from "../../layouts/TwoSidebars/TwoSidebars";
import { MdHome, MdLinkOff } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
import { useLocation, useNavigate } from "react-router-dom";
import useCurrentUser from "../../hooks/useCurrentUser";
import { EButtonKind } from "src/components/Button/ButtonTypes";

const NotFound404: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { accounts } = useCurrentUser();
  const allAccounts = accounts?.data?.data;
  const hasAccounts = allAccounts?.length;
  const isReportsPage = pathname === "/reports" || pathname === "/reports/";
  const isTransactionsPage =
    pathname === "/transactions" || pathname === "/transactions/";

  return (
    <TwoSidebars>
      <div
        className={clsx([
          "flex",
          "w-full",
          "items-center",
          "justify-center",
          "flex-col",
          "gap-3",
          "p-4",
          "h-[calc(100vh-220px)]",
          "text-gray-400",
        ])}
      >
        <MdLinkOff size={ICON_SIZES.XL * 2} />
        <div className={clsx(["text-center", "text-sm"])}>
          <h1 className={clsx(["text-2xl", "md:text-4xl", "font-normal"])}>
            Ópale!
          </h1>
          <p>La página a la que intentas acceder no existe.</p>
        </div>
        <div
          className={clsx([
            "mt-6",
            {
              hidden:
                !hasAccounts ||
                ![isReportsPage, isTransactionsPage].includes(true),
            },
          ])}
        >
          <ButtonGroup
            buttons={[
              {
                text: "Inicio",
                icon: <MdHome size={ICON_SIZES.MD} />,
                onClick: () => {
                  const [defaultAccount] = allAccounts;

                  if (isReportsPage) {
                    navigate(`/reports/${defaultAccount?.account}`);
                  } else if (isTransactionsPage) {
                    navigate(`/transactions/${defaultAccount?.account}`);
                  }
                },
                kind: EButtonKind.SAVE,
              },
            ]}
            align="center"
          />
        </div>
      </div>
    </TwoSidebars>
  );
};

export default NotFound404;
